module.exports = __webpack_public_path__ + "img/avatar7.daf89886.png";